import Vue from 'vue'


Vue.directive('scroll', {
    inserted: (el, binding)  => {
      let eventFunction = (event) => {
          if (binding.value(event, el)) {
            window.removeEventListener('scroll', eventFunction)
        }
      }
      window.addEventListener('scroll', eventFunction)
    }
  })

export default {
    directives:{
        scroll: scroll
    }
}